import Vue from 'vue'
import VueRouter from 'vue-router'
import authRoutes from '../views/pages/auth/routes'
import recoveryRoutes from '../views/pages/recoveryAccess/routes'
import homeRoutes from '../views/pages/home/routes'
import dashboardpreRoutes from '../views/pages/dashboard/routes'

import cadasterRoutes from '../views/pages/cadaster/routes'
import buyCreditRoutes from '../views/pages/comprarCreditos/routes'
import cadasterDriverRoutes from '../views/pages/cadastrarMotorista/routes'
import myOrdersRoutes from '../views/pages/pedidos/routes'
import colaboratorsRoutes from '../views/pages/colaborators/routes'
import accountSettingsRoutes from '../views/pages/enterprise/routes'
import authLabetRoutes from '../views/pages/authLabet/routes'
import labsRoutes from '../views/pages/labs/routes'
import faturamentoRoutes from '../views/pages/faturamento/routes'
import resetPasswordRoutes from '../views/pages/resetPassword/routes'
import notificationsRoutes from '../views/pages/notifications/routes'
import certificatesRoutes from '../views/pages/certificates/routes'
import selectedListroutes from '../views/pages/listaDeSelecionados/routes'
import buyPlanRoutes from '../views/pages/comprarPlanos/routes'

import myBuysRoutes from '../views/pages/minhasCompras/routes'
import enterpriseRoutes from '../views/pages/enterprise/routes'
import registerTermRoutes from '../views/pages/registerTerm/routes'
import loginRegisterRoutes from '../views/pages/loginRegister/routes'
import gerenteRoutes from '../views/pages/gerente/routes'
import faturamentoGerenteRoutes from '../views/pages/faturamentoGerente/routes'
import gerenteCadastroRoutes from '../views/pages/gerenteCadastro/router'
import gerenteCadastroLoteRoutes from '../views/pages/gerenteCadastroLote/router'
import moment from 'moment'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/home',
  },

  {
    path: '/auth',
    ...authRoutes,
  },
  {
    path: '/adminLabet',
    ...authLabetRoutes,
  },
  {
    path: '/recovery',
    ...recoveryRoutes,
  },
  {
    path: '/home',
    ...homeRoutes,
  },
  {
    path: '/gerente',
    ...gerenteRoutes,
  },
  {
    path: '/faturamentoGerente',
    ...faturamentoGerenteRoutes,
  },
  {
    path: '/gerenteCadastro',
    ...gerenteCadastroRoutes,
  },
  {
    path: '/gerenteCadastroLote',
    ...gerenteCadastroLoteRoutes,
  },

  {
    path: '/dashboard',
    ...dashboardpreRoutes,
    meta: { requiresAuth: true },
  },
  {
    path: '/buyCredit',
    ...buyCreditRoutes,
    meta: { requiresAuth: true },
  },
  {
    path: '/cadasterDriver',
    ...cadasterDriverRoutes,
    meta: { requiresAuth: true },
  },
  {
    path: '/myOrders',
    ...myOrdersRoutes,
    meta: { requiresAuth: true },
  },

  {
    path: '/accountSettings',
    ...accountSettingsRoutes,
    meta: { requiresAuth: true },
  },

  {
    path: '/myBuys',
    ...myBuysRoutes,
    meta: { requiresAuth: true },
  },
  {
    path: '/certificates/random',
    ...certificatesRoutes,
    meta: { requiresAuth: true },
  },
  {
    path: '/selected-list/random',
    ...selectedListroutes,
    meta: { requiresAuth: true },
  },
  {
    path: '/buyPlan/random',
    ...buyPlanRoutes,
    meta: { requiresAuth: true },
  },

  {
    path: '/enterprise',
    ...enterpriseRoutes,
    meta: { requiresAuth: true },
  },
  {
    path: '/colaborators',
    ...colaboratorsRoutes,
    meta: { requiresAuth: true },
  },
  {
    path: '/labs',
    ...labsRoutes,
    meta: { requiresAuth: true },
  },
  {
    path: '/invoicing',
    ...faturamentoRoutes,
    meta: { requiresAuth: true },
  },
  {
    path: '/update-password',
    ...resetPasswordRoutes,
    meta: { requiresAuth: true },
  },
  {
    path: '/notifications',
    ...notificationsRoutes,
    meta: { requiresAuth: true },
  },

  {
    path: '/cadaster',
    ...cadasterRoutes,
  },
  {
    path: '/registerTerm',
    ...registerTermRoutes,
  },
  {
    path: '/loginRegister',
    ...loginRegisterRoutes,
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return window.scrollTo({
        top: document.querySelector(to.hash).offsetTop,
        behavior: 'smooth',
      })
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes,
})

router.beforeEach(async (to, from, next) => {
  if (to == from) {
    return
  }

  let token = localStorage.getItem('token')
  let expiresToken = localStorage.getItem('validTo')
  let user = JSON.parse(localStorage.getItem('user'))

  if (to.meta.requiresAuth) {
    if (token) {
      if (moment().isBefore(moment(expiresToken, 'yyyy-MM-DD HH:mm:ss'))) {
        next()
      } else {
        next('/home')
      }
    } else {
      next('/home')
    }
  } else {
    next()
  }
})

export default router
